// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3nO9F","label":"Category_label__3EUFM","content":"Category_content__2yUYt","header":"Category_header__3SreD","location":"Category_location__3JnN1"};